import { AccountOperParams } from '../models'
import { HttpServiceResponse } from '../../shared'
import { AccountOperActions } from '../models/account.types'
import AbstractAccountProvider from './account-abstract.provider'

export class AccountOperProvider extends AbstractAccountProvider {
  urlPath = 'acc_account_oper_api'

  public oper<T>(action: AccountOperActions, params: Partial<AccountOperParams>): Promise<HttpServiceResponse<T>> {
    const query = this.query.stringify({
      action,
      ...params,
    })

    return this.http.post(`${this.url}?${query}`)
  }
}
